import React,{useState} from 'react'
import axios from 'axios'
import {AuthProvider,useAuth} from '../index'
import { Link as RouterLink} from 'react-router-dom'
import { IoIosArrowBack } from 'react-icons/io'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import Person from '@mui/icons-material/Person'
import Settings from '@mui/icons-material/Settings'
import LinearProgress from '@mui/material/LinearProgress'
import Alert from '@mui/material/Alert'
import Avatar from '@mui/material/Avatar'
import TextField from '@mui/material/TextField'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Button from '@mui/material/Button'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuIcon from '@mui/icons-material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { MdEdit } from 'react-icons/md'
import { IoMdClose,IoIosLogOut } from 'react-icons/io'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`

export default function ResetPwdPage(){
    const { login, auth2FA1 } = useAuth()
    const [msg, setMsg] = useState('')
    const [data, setData] = useState('')
    const [loginBtn, setLoginBtn] = useState(false)
    const [resendBtn, setResendBtn] = useState(false)
    const onChangeInput = ({ currentTarget: input }) => { setData({ ...data, [input.name]: input.value }) }
    const onClick2ResetPwd = async() =>{
        setLoginBtn(true)
        const tmpId =`${Math.floor(Math.random() * 1000000)}`
        const newData = { ...data, ['pwd']: tmpId }
        const { data: res } = await axios.post(`${APIURL}/reset-pwd`, newData)
        setMsg(res.msg)
    }
    const onClick2ResendConfirmation = async() =>{
        setResendBtn(true)
        const { data: res } = await axios.post(`${APIURL}/resend-confirmation`, data)
        console.log(res)
        setResendBtn(false)
        // loginData1({
        //   id:res.user.id,
        //   username:res.user.username,
        //   email:data.email,
        //   pwd:data.pwd,
        //   role:res.user.role,
        //   msg:res.msg,
        //   iatstring:new Date(Number(res.tokenInfo.iat)*1000).toString(),
        //   expstring:new Date(Number(res.tokenInfo.exp)*1000).toString(),
        //   iat:Number(res.tokenInfo.iat),
        //   exp:Number(res.tokenInfo.exp),
        //   justLogined:'true',
        //   users:res.users
        // })
        // setJustLogined(true)
        // {msg: "You are logined.", tokenInfo: {exp: "1745678963", iat: "1745074163", token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6I…jMifQ.4V2HjqSX0CLwn2yxZZNQErcuqwkD89o7odUtNsKTF8w"},
        // user: confirmed: "ok"
        // email: "kaede.nakashima@protonmail.com"
        // pwd: "$2b$14$9dRbTIv.ieGzz8uUMEycoOouFQR76BNQrm2I0g/Quk1H/07jgt0hK"
        // role: "free"
        // if (res.msg==='You are logined.'){
        //     setMsg(res.msg)
        //     localStorage.setItem('token', res.tokenInfo.token)
        //     // const email = res.user.email
        //     const code = '1'
        //     // await login({ email })
        //     // await login(res.user)
        //     await login({'username':res.user.username,'url':`https://ui-avatars.com/api/?name=${res.user.firstname[0]}+${res.user.lastname[0]}&background=000&color=fff`})
        //     await auth2FA1({ code })
        // }
        // setMsg(res.msg)
    }
    return(
        <>
        <div className='mt-4 m-auto structure__login__container'>
        <h2 className='mb-4 text-lg structure__main__subttl'>Password Reset</h2>
        <div className='w-fit m-auto flex structure__login__input__container'>
        <div className='text-[11px] mt-[6px] mr-1 bitter'>Email</div>
        <div className='flex-col'>
        <input name='email' className='bitter border-[1px] border-gray-800 structure__login__input w-full md:w-96' onChange={onChangeInput}/>
        <div className='mt-1 flex w-full text-center'><button className='hover:bg-[#365c88] disabled:bg-[#dcdcdc] disabled:border disabled:border-gray-200 bg-[#414c75] h-[28px] text-[13px] pl-[12px] pr-[12px] text-white m-auto font-medium bitter' onClick={onClick2ResetPwd}  disabled={loginBtn}>Send Reset Mail</button></div>
        {msg=='You need to confirm your account from mailbox first.'?<div className='m-auto structure__login__input__container mt-8'>
        <input name='registered_email' className='primary-input structure__login__input w-full md:w-[340px]' placeholder='Your registered email' onChange={onChangeInput}/><button className='third-btn ml-1 bitter' onClick={onClick2ResendConfirmation} disabled={resendBtn}>Resend</button>
        </div>:''}
        <div className='text-center mt-[8px] text-[12px] bitter'>{msg}</div>
        <div className='text-[9px] m-auto w-fit'><RouterLink className='text-center underline flex bitter text-[12px]' to='/login'><IoIosArrowBack className='m-auto'/>Go back</RouterLink></div>
        </div>
        </div>
        <br/><br/>
        </div>
        </>
    )
}